import { jsxs as r, jsx as e, Fragment as M } from "react/jsx-runtime";
import v from "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import o from "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import p from "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import B from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import L from "@material-ui/lab/Alert";
import { TextField as u, MaterialPhoneMaskInput as T } from "@propify-tenant-client/common";
import { getSdkUnitDetailsClassName as m } from "../../utils/sdk.js";
import d from "classnames";
import k from "lodash/isEmpty";
const C = B({
  form: {
    "& label.Mui-required .MuiInputLabel-asterisk": {
      color: "red"
    },
    "& .MuiGrid-item": {
      margin: 8
    },
    "&.noMargin .MuiGrid-item": {
      margin: "8px 0"
    },
    "& label": {
      color: "black",
      fontWeight: "500",
      marginBottom: 8,
      fontSize: "0.93rem"
    },
    "& .MuiOutlinedInput-input": {
      height: "0.5em"
    },
    "& .MuiInputBase-input, & .MuiInputBase-multiline": {
      background: "#EBF5FF",
      borderColor: "#CDDFF0"
    },
    "& .messageField textarea": {
      minHeight: 60
    },
    "& .MuiFormHelperText-root.Mui-error": {
      marginBottom: -5
    }
  }
}), y = {
  firstName: 12,
  lastName: 12,
  email: 12,
  message: 12,
  phone: 12
}, ye = ({
  formProps: h,
  noMargin: f = !1,
  login: g,
  success: N,
  layout: a = y
}) => {
  const { handleChange: n, handleBlur: s, errors: i, touched: x, values: l } = h, F = C(), b = !k(g), t = (c) => x[c] && !!i[c];
  return /* @__PURE__ */ r(
    o,
    {
      container: !0,
      spacing: 2,
      className: d(
        F.form,
        m("contact-form-container"),
        "enable-default-input-background",
        { noMargin: f }
      ),
      children: [
        N && /* @__PURE__ */ e(v, { mb: 2, mt: 1, children: /* @__PURE__ */ e(L, { severity: "success", children: "Thank you for submitting the form! One of our agents will get back to you soon." }) }),
        !b && /* @__PURE__ */ r(M, { children: [
          /* @__PURE__ */ r(o, { item: !0, className: "propify-contact-us-input", xs: a.firstName, children: [
            /* @__PURE__ */ e(p, { htmlFor: "firstName", required: !0, children: "First Name" }),
            /* @__PURE__ */ e(
              u,
              {
                className: m("contact-input"),
                id: "firstName",
                name: "firstName",
                value: l.firstName,
                error: t("firstName"),
                helperText: t("firstName") && i.firstName,
                variant: "outlined",
                hiddenLabel: !0,
                fullWidth: !0,
                onChange: n,
                onBlur: s
              }
            )
          ] }),
          /* @__PURE__ */ r(o, { item: !0, className: "propify-contact-us-input", xs: a.lastName, children: [
            /* @__PURE__ */ e(p, { htmlFor: "lastName", required: !0, children: "Last Name" }),
            /* @__PURE__ */ e(
              u,
              {
                className: m("contact-input"),
                id: "lastName",
                name: "lastName",
                value: l.lastName,
                error: t("lastName"),
                helperText: t("lastName") && i.lastName,
                variant: "outlined",
                hiddenLabel: !0,
                fullWidth: !0,
                onChange: n,
                onBlur: s
              }
            )
          ] }),
          /* @__PURE__ */ r(o, { item: !0, className: "propify-contact-us-input", xs: a.email, children: [
            /* @__PURE__ */ e(p, { htmlFor: "email", required: !0, children: "Email" }),
            /* @__PURE__ */ e(
              u,
              {
                className: m("contact-input"),
                id: "email",
                name: "email",
                value: l.email,
                error: t("email"),
                helperText: t("email") && i.email,
                variant: "outlined",
                hiddenLabel: !0,
                fullWidth: !0,
                onChange: n,
                onBlur: s
              }
            )
          ] }),
          /* @__PURE__ */ r(o, { item: !0, className: "propify-contact-us-input", xs: a.phone, children: [
            /* @__PURE__ */ e(p, { htmlFor: "phone", required: !0, children: "Phone" }),
            /* @__PURE__ */ e(
              T,
              {
                id: "phone",
                name: "phone",
                value: l.phone,
                error: t("phone"),
                helperText: t("phone") && i.phone,
                variant: "outlined",
                hiddenLabel: !0,
                fullWidth: !0,
                onChange: n,
                onBlur: s,
                className: m("contact-input")
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ r(o, { item: !0, className: "propify-contact-us-input", xs: a.message, children: [
          /* @__PURE__ */ e(p, { htmlFor: "message", children: "Message (optional)" }),
          /* @__PURE__ */ e(
            u,
            {
              id: "message",
              name: "message",
              value: l.message,
              className: d(
                "messageField",
                m("contact-input-message")
              ),
              multiline: !0,
              error: t("message"),
              helperText: t("message") && i.message,
              variant: "outlined",
              hiddenLabel: !0,
              fullWidth: !0,
              onChange: n,
              onBlur: s
            }
          )
        ] })
      ]
    }
  );
};
export {
  ye as default
};
//# sourceMappingURL=LeadForm.js.map
